import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const HelpSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22.0044C17.4667 22.0044 22 17.4778 22 12.0044C22 6.53098 17.458 2.00439 11.9869 2.00439C6.5207 2.00439 2 6.53098 2 12.0044C2 17.4778 6.52941 22.0044 11.9957 22.0044ZM11.9957 20.5316C7.27809 20.5316 3.48562 16.7327 3.48562 12.0044C3.48562 7.27606 7.26938 3.47716 11.9869 3.47716C16.7132 3.47716 20.5192 7.27606 20.5192 12.0044C20.5192 16.7327 16.7219 20.5316 11.9957 20.5316ZM11.8055 14.0396C12.2403 14.0396 12.5067 13.7604 12.5067 13.4086C12.5067 13.352 12.5067 13.2955 12.5067 13.2389C12.5067 12.6735 12.8153 12.3209 13.5271 11.8438C14.4961 11.2026 15.1319 10.6219 15.1319 9.48558C15.1319 7.92734 13.7363 7.04365 12.0905 7.04365C10.4235 7.04365 9.33774 7.8694 9.09357 8.79919C9.04612 8.95636 9.01999 9.10179 9.01999 9.26679C9.01999 9.66131 9.326 9.87554 9.62545 9.87554C9.93361 9.87554 10.1255 9.73492 10.2696 9.50502L10.4177 9.29557C10.7098 8.6636 11.2805 8.23374 12.0305 8.23374C12.9963 8.23374 13.6132 8.7761 13.6132 9.55831C13.6132 10.2313 13.2155 10.5812 12.327 11.1972C11.5947 11.7121 11.1003 12.2345 11.1003 13.1662C11.1003 13.2219 11.1003 13.2871 11.1003 13.3389C11.1003 13.7953 11.3532 14.0396 11.8055 14.0396ZM11.7842 16.9246C12.3116 16.9246 12.7682 16.491 12.7682 15.9663C12.7682 15.4251 12.3203 15.008 11.7842 15.008C11.2432 15.008 10.7914 15.4338 10.7914 15.9663C10.7914 16.4822 11.2519 16.9246 11.7842 16.9246Z"
        fill={color}
      />
    </svg>
  );
};

export { HelpSvg };
